module.exports = __webpack_public_path__ + "img/feature4.6c0d4aa1.png";